
/**
 * Scrolls to the specified section ID with smooth behavior
 * @param sectionId HTML element ID to scroll to
 */
export const scrollToSection = (sectionId: string): void => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  } else {
    console.warn(`Element with ID "${sectionId}" not found`);
  }
};

/**
 * Navigates to a section, handling cross-page navigation
 * @param sectionId HTML element ID to scroll to
 * @param currentPath Current route path
 * @param navigate React Router navigate function
 */
export const navigateToSection = (
  sectionId: string,
  currentPath: string,
  navigate: (path: string) => void
): void => {
  if (currentPath === '/') {
    // Already on homepage, just scroll
    scrollToSection(sectionId);
  } else {
    // Navigate to homepage with hash, then scroll will happen automatically
    navigate(`/#${sectionId}`);
  }
};
